function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_ACTIVITY_BEGIN, logError, fetchActivitySuccess } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function fetchActivity(action$, state$) {
    return action$.pipe(ofType(FETCH_ACTIVITY_BEGIN), mergeMap(function(action) {
        var currentTopic = _objectSpread({}, action.topic);
        return from(SocialAPIUtils.getActivity(action.activity, currentTopic)).pipe(switchMap(function(activity) {
            var actions = [
                fetchActivitySuccess({
                    activity: activity,
                    topic: currentTopic
                })
            ];
            return actions;
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_activity"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_activity"
        }));
    }));
}
